import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing, colors }: Theme) => createStyles({
  logo: {
    '& div': {
      display: 'flex',
      height: spacing(8),
      width: spacing(8),
      justifyContent: 'center',
      alignItems: 'center',

      '& svg': {
        height: spacing(8),
        width: spacing(8),
        fill: colors.pageElements.logo.enabled.fill,
        '& path': {
          fill: colors.pageElements.logo.enabled.fill,
        },
      },
    },
  },
  appTitle: {
    marginLeft: spacing(2),
    flex: 1,
    color: colors.navigation.logoLink.name,
  },
});

export default styles;
